module.exports = __webpack_public_path__ + "static/media/value-over-price-card.483a75c8.jpeg";